import { updatesData } from '@/mocks/home';

export default function Updates() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-3">
          最新动态
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">实时追踪娱乐圈最新事件与话题动态</p>

        <div className="max-w-[800px] mx-auto">
          {updatesData.map((item, i) => (
            <div
              key={i}
              className="flex items-start gap-4 py-3 border-b border-background-200 last:border-b-0 cursor-pointer hover:bg-background-100/50 transition-colors rounded px-3"
            >
              {/* Date */}
              <span className="text-xs font-bold text-primary-600 bg-primary-50 px-2 py-1 rounded whitespace-nowrap mt-0.5">
                {item.date}
              </span>

              {/* Dot + line */}
              <div className="hidden sm:flex flex-col items-center pt-1.5">
                <div className={`w-2 h-2 rounded-full ${i === 0 ? 'bg-primary-500 ring-4 ring-primary-100' : 'bg-background-300'}`}></div>
                {i < updatesData.length - 1 && (
                  <div className="w-px h-6 bg-background-200"></div>
                )}
              </div>

              {/* Content */}
              <div className="flex-1 min-w-0">
                <span className="inline-block px-2 py-0.5 bg-secondary-100 text-secondary-700 text-[10px] font-bold rounded mr-2 whitespace-nowrap">
                  {item.type}
                </span>
                <p className="inline text-sm text-foreground-800 leading-relaxed">
                  {item.title}
                </p>
              </div>

              {/* Arrow */}
              <span className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                <i className="ri-arrow-right-s-line text-foreground-300 text-sm"></i>
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}